import { api } from '@/store/service';
import EventBus from '@/eventBus';

const InitialState = {
  company_id: '',
  company_name: '',
  company_cusip: '',
  company_cusips: [],
  company_cik: [],
  company_length: 0,
  stockPrice: 0,
  admin_user_id: '',
  billing_type: '',
  isAccountDisabled: false,
  has_payment_method: false,
  parent_company_id: '',
  parent_company_name: '',
  company_address: '',
  company_city: '',
  company_country_name: '',
  company_country_code: '',
  company_state: '',
  company_symbol: '',
  company_zip_code: '',
  chatbot_setup: false,
  chatbot_sync_required: false,
  nobo_report_date: '',
  spr_report_date: '',
};

const mutations = {
  update(state, company) {
    const data = {
      company_id: company.company_id || '',
      company_name: company.company_name || '',
      company_cusip: company.company_cusip ? company.company_cusip[0] : '',
      company_cusips: company.company_cusip ? company.company_cusip : [],
      company_length: company.company_length || 0,
    };

    return Object.assign(state, data);
  },
  updateStockPrice(state, stockPrice) {
    return Object.assign(state, { stockPrice });
  },
  updateNoboSprReportDate(state, { noboReport, sprReport }) {
    const data = {
      nobo_report_date: noboReport,
      spr_report_date: sprReport,
    };

    return Object.assign(state, data);
  },
  updatePaymentInfo(state, paymentInfo) {
    const company = {
      admin_user_id: paymentInfo.admin_user_id || '',
      billing_type: paymentInfo.billing_type || '',
      has_payment_method: paymentInfo.has_payment_method || false,
      parent_company_id: paymentInfo.parent_company_id || '',
      parent_company_name: paymentInfo.parent_company_name || '',
      company_address: paymentInfo.company_address || '',
      company_city: paymentInfo.company_city || '',
      company_country_name: paymentInfo.company_country_name || '',
      company_country_code: paymentInfo.company_country_code || '',
      company_state: paymentInfo.company_state || '',
      company_symbol: paymentInfo.company_symbol || '',
      company_zip_code: paymentInfo.company_zip_code || '',
      company_cik: paymentInfo.company_cik || [],
    };
    return Object.assign(state, company);
  },
  isAccountDisabled(oldState, isAccountDisabled) {
    return Object.assign(oldState, { isAccountDisabled });
  },
  setChatbotSetup(state, chatbotSetup) {
    return Object.assign(state, { chatbot_setup: chatbotSetup });
  },
  setChatbotSyncReq(state, chatbotSync) {
    return Object.assign(state, { chatbot_sync_required: chatbotSync });
  },
};

const actions = {
  async load({ commit }) {
    try {
      const company = await api('get', 'profiles/companies');
      let currentCompany = [];
      if (this.state.company.company_id !== '') {
        currentCompany = company.filter((e) => e.company_id === this.state.company.company_id);
      }

      if (currentCompany.length > 0) {
        currentCompany[0].company_length = company.length;
        commit('isAccountDisabled', (currentCompany[0].billing_type === 'CARD' && (currentCompany[0].company_payment_status === 'FAILED' || currentCompany[0].company_payment_status === '')));
      } else if (company[0]) {
        company[0].company_length = company.length;
        commit('isAccountDisabled', (company[0].billing_type === 'CARD' && (company[0].company_payment_status === 'FAILED' || company[0].company_payment_status === '')));
      }

      await commit('update', currentCompany.length > 0 ? currentCompany[0] : company[0] || []);
      EventBus.$emit('getInsightsOverview');
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async getPaymentInfo({ commit }) {
    try {
      if (!this.state.company.company_id) return;
      const res = await api('get', `companyProfiles?company_id=${this.state.company.company_id}`, { });
      const company = {
        admin_user_id: res.admin_user_id,
        billing_type: res.billing_type,
        has_payment_method: res.has_payment_method,
        parent_company_id: res.parent_company_id,
        parent_company_name: res.parent_company_name,
        company_address: res.company_address,
        company_city: res.company_city,
        company_country_name: res.company_country_name,
        company_country_code: res.company_country_code,
        company_state: res.company_state,
        company_symbol: res.company_symbol,
        company_zip_code: res.company_zip_code,
        company_cik: res.company_cik,
      };

      await commit('updatePaymentInfo', company);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
};

const getters = {
  company_id: (state) => state.company_id,
  company: (state) => state,
};

export default {
  state: InitialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
